import TasksContainer from '../containers/TasksContainer'

export const TASKS = '/tasks'

export const TasksRoutes = [
  {
    key: 'tasks',
    exact: true,
    path: TASKS,
    component: TasksContainer,
  },
]
